module.exports = __webpack_public_path__ + "static/media/landing-3.f53ce89c.jpg";